import React from 'react';
import { Box, Checkbox, FormControlLabel, TextField, Typography } from '@mui/material';

import SelectEmpresa from '../../../form/SelectEmpresa';
import DataList from '../../../form/DataList';
import Input from '../../../form/Input';

const campoSx = {
    minWidth: 0,

    '& > *': {
        width: '100%',
        margin: '0 !important',
        boxSizing: 'border-box',
    },

    '& label': {
        display: 'block',
        marginBottom: '4px',
    },

    '& input, & select': {
        width: '100% !important',
        maxWidth: '100%',
        minWidth: 0,
        height: '36px',
        margin: '0 !important',
        boxSizing: 'border-box',
    },
};

export default function CabecalhoTab({ tipo, modulo: m, bloqueado }) {
    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: {
                    xs: 'minmax(0, 1fr)',
                    md: 'repeat(12, minmax(0, 1fr))',
                },
                gap: 2,
                py: 2,
                alignItems: 'start',
            }}
        >
            <Box
                sx={{
                    ...campoSx,
                    gridColumn: { xs: '1 / -1', md: 'span 4' },
                }}
            >
                <fieldset
                    disabled={bloqueado || m.editando}
                    style={{
                        border: 0,
                        padding: 0,
                        margin: 0,
                        minWidth: 0,
                    }}
                >
                    <SelectEmpresa
                        text="Empresa"
                        name="empresaId"
                        options={m.empresas}
                        handleOnChange={m.alterar}
                        value={m.dados.empresaId || ''}
                        required
                        notOptNull
                    />
                </fieldset>
            </Box>

            <Box
                sx={{
                    ...campoSx,
                    gridColumn: { xs: '1 / -1', md: 'span 8' },
                }}
            >
                <Input
                    type="text"
                    text={tipo ? 'Descrição do tipo' : 'Título do documento'}
                    name={tipo ? 'descricao' : 'titulo'}
                    value={(tipo ? m.dados.descricao : m.dados.titulo) || ''}
                    handleOnChange={m.alterar}
                    readonly={bloqueado}
                    inputWidth="100%"
                    required
                />
            </Box>

            {!tipo && (
                <>
                    <Box
                        sx={{
                            ...campoSx,
                            gridColumn: { xs: '1 / -1', md: 'span 8' },
                        }}
                    >
                        <DataList
                            text="Tipo de documento"
                            name="tipoDescricao"
                            value={m.dados.tipoDescricao || ''}
                            inputWidth="100%"
                            filteredOptions={m.tipos}
                            handleOnChange={m.alterar}
                            handleOnFocus={() => m.consultarTipos('')}
                            readonly={bloqueado}
                            placeholder="Pesquise e selecione um tipo"
                        />

                        {m.buscandoTipos && <Typography variant="caption">Consultando tipos...</Typography>}
                    </Box>

                    <Box
                        sx={{
                            ...campoSx,
                            gridColumn: { xs: '1 / -1', md: 'span 4' },
                        }}
                    >
                        <Input
                            type="date"
                            text="Data do documento"
                            name="dataDocumento"
                            value={m.dados.dataDocumento || ''}
                            handleOnChange={m.alterar}
                            readonly={bloqueado}
                            inputWidth="100%"
                        />
                    </Box>

                    <TextField
                        label="Observações / palavras para pesquisa"
                        name="observacao"
                        value={m.dados.observacao || ''}
                        onChange={m.alterar}
                        disabled={bloqueado}
                        multiline
                        minRows={4}
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ maxLength: 15000 }}
                        sx={{ gridColumn: '1 / -1' }}
                    />
                </>
            )}

            <FormControlLabel
                sx={{ gridColumn: '1 / -1', margin: 0 }}
                control={<Checkbox name="ativo" checked={Boolean(m.dados.ativo)} onChange={m.alterar} disabled={bloqueado} />}
                label="Ativo"
            />
        </Box>
    );
}
